"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoRating = exports.BodyContainer = exports.DateContainer = exports.StarContainer = exports.StarsContainer = exports.ReviewHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ReviewHeader = styled_1.default.div `
  display: flex;
  justify-content: space-between;
`;
exports.StarsContainer = styled_1.default.ul `
  padding: 0;
  display: flex;
  color: ${({ iconColor }) => iconColor ? iconColor : (0, ui_theme_1.fromTheme)('color_star_ratings')};
  font-size: 1rem;

  svg path {
    fill: currentColor !important;
  }
`;
exports.StarContainer = styled_1.default.li `
  list-style: none;
  margin-right: 2px;
`;
exports.DateContainer = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
`;
exports.BodyContainer = styled_1.default.p `
  && {
    margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
  }
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: 1.64;
`;
exports.NoRating = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
//# sourceMappingURL=individual-review.styles.js.map